import { instance, errorService } from '@/services/api'
import { dropdownAPIs, masterAPIs, screenType } from '@/services/authConstantsV1'
import _ from 'lodash'
import { AgGridVue } from 'ag-grid-vue'
import { calculateGridHeight, showNotification, customComparator } from '@/services/calculate'
import Pagination from '@/components/DynamicComponents/Pagination'
import { gridProperties } from '@/services/column.config'

export default {
  components: {
    'ag-grid-vue': AgGridVue,
    Pagination,
  },
  props: {
    tabKey: String,
    role: String,
  },
  data: function () {
    const checkLength = (rule, value, callback) => {
      if (String(value).length > 100) {
        callback(
          new Error(
            'Structural profile must be less than or equals to 100 characters',
          ),
        )
      } else {
        callback()
      }
    }
    return {
      headStyle: {
        'font-weight': 'bold',
        background: 'transparent !important',
        color: '#000000d9 !important',
        padding: '0 10px',
      },
      count: 0,
      defaultSortedBy: 'structureProfile',
      defaultSortOrder: true,
      page: 0,
      pageSize: 0,
      structureProfileList: [],
      loadRefresh: false,
      gridOptions: null,
      columnDefs: [],
      frameworkComponents: null,
      tableParams: null,
      width: '100%',
      height: '400px',
      loading: true,
      visible: false,
      modalTitle: '',
      form: {
        id: undefined,
        structureProfile: undefined,
        buildingUses: [],
        isActive: 1,
      },
      rules: {
        structureProfile: [
          {
            required: true,
            message: 'Please enter structure profile',
            trigger: 'blur',
          },
          { validator: checkLength, trigger: 'blur' },
        ],
        buildingUses: [
          {
            type: 'array',
            required: true,
            message: 'Please select at least one building use',
            trigger: 'change',
          },
        ],
      },
      buildingUseList: [],
      spinner: false,
      filters: {},
      tableState: null,
    }
  },
  beforeMount() {
    const settings = JSON.parse(localStorage.getItem('userSettings'))
    this.pageSize = settings.application.defaultRecord
    this.loadConfig()
    if (this.role === 'Admin') {
      this.getBuildingUses()
    }
  },
  mounted() {
    this.$root.$on('editProfile', this.getStructureProfileById)
    window.addEventListener('resize', this.getWindowSize)
  },
  beforeDestroy() {
    this.$root.$off('editProfile')
    window.removeEventListener('resize', this.getWindowSize)
  },
  watch: {
    tabKey() {
      if (this.tabKey === '2') {
        this.filters = {}
        const data = this.gridOptions.api.getFilterModel()
        Object.keys(data).forEach(element => {
          const filterComponent = this.gridOptions.api.getFilterInstance(
            element,
          )
          filterComponent.setModel(null)
        })
        this.loading = true
        this.structureProfileList = []
        this.getBuildingUses()
        this.getColumnSettings(this.gridOptions)
      }
    },
  },
  methods: {
    loadConfig() {
      this.gridOptions = {
        alwaysShowVerticalScroll: true,
        debounceVerticalScrollbar: true,
        alwaysShowHorizontalScroll: true,
        headerHeight: 30,
        rowHeight: 28,
        suppressRowClickSelection: true,
        singleClickEdit: true,
        stopEditingWhenGridLosesFocus: true,
        tooltipShowDelay: 0,
        rowSelection: 'multiple',
        defaultColDef: {
          sortable: true,
          suppressMovable: true,
          comparator: customComparator,
          resizable: true,
          menuTabs: ['filterMenuTab'],
          filterParams: {
            buttons: ['apply'],
            newRowsAction: 'keep',
          },
        },
      }
      this.frameworkComponents = gridProperties.master.frameworks
      this.columnDefs = gridProperties.master.columns.structuralProfile
    },

    // Refresh Structure Profiles
    refreshStructureProfiles() {
      const data = this.gridOptions.api.getFilterModel()
      Object.keys(data).forEach(element => {
        const filterComponent = this.gridOptions.api.getFilterInstance(element)
        filterComponent.setModel(null)
      })
      this.loading = true
      this.loadRefresh = true
      this.structureProfileList = []
      this.page = 0
      this.defaultSortedBy = 'structureProfile'
      this.defaultSortOrder = true
      this.gridOptions.columnApi.applyColumnState({
        state: [
          {
            colId: 'structureProfile',
            sort: 'asc',
          },
        ],
        defaultState: { sort: null },
      })
      this.gridOptions.api.destroyFilter()
      this.filters = {}
      this.getStructureProfiles(this.gridOptions)
    },

    // Load Structure Profiles
    getStructureProfiles(params, type) {
      const req = {
        PageSize: this.pageSize,
        CurrentPage: this.page,
        SortColumn: this.defaultSortedBy,
        IsAscending: this.defaultSortOrder,
      }
      const data = this.gridOptions.api.getFilterModel()
      Object.keys(data).forEach((element, index) => {
        if (Object.values(data)[index]['filter'] !== '') {
          if (element === 'buildingUses') {
            req['buildingUse'] = Object.values(data)[index]['filter']
          } else {
            req[element] = Object.values(data)[index]['filter']
          }
        }
      })
      instance
        .post(masterAPIs.structureProfile.list, req)
        .then(response => {
          this.tableParams = null
          this.tableParams = params
          this.structureProfileList = _.get(response.data, 'result', [])
          this.count = _.get(response.data, 'totalCount', 0)
          this.gridOptions.api.setRowData(this.structureProfileList)
          this.height = calculateGridHeight(
            'proprtyTypeTable',
            this.count > this.pageSize,
          )
          this.loadRefresh = false
          this.loading = false
          if (type === 'sort') {
            this.updateColumnSettings()
          }
        })
        .catch(error => {
          this.loadRefresh = false
          this.loading = false
          errorService(error)
        })
    },

    // Ag Grid sort method
    sortChanged(value) {
      const colState = this.gridOptions.columnApi.getColumnState()
      const sortData = colState
        .filter(function (s) {
          return s.sort != null
        })
        .map(function (s) {
          return {
            colId: s.colId,
            sort: s.sort,
            sortIndex: s.sortIndex,
          }
        })
      this.loading = true
      this.structureProfileList = []
      if (sortData.length > 0) {
        this.defaultSortedBy = sortData[0]['colId']
        this.defaultSortOrder = sortData[0]['sort'] === 'asc'
      } else {
        this.defaultSortedBy = 'structureProfile'
        this.defaultSortOrder = true
      }
      this.getStructureProfiles(this.gridOptions, 'sort')
    },

    // Close the dialog
    handleCancel() {
      this.visible = false
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.resetFields()
      }
    },

    // Get Structure Profile By Id
    getStructureProfileById(id) {
      this.modalTitle = 'Edit'
      this.visible = true
      this.spinner = true
      instance
        .get(masterAPIs.structureProfile.details(id))
        .then(response => {
          const type = _.get(response.data, 'result', null)
          this.form.structureProfile = type.structureProfile
          this.form.id = type.id
          this.form.buildingUses = []
          this.form.isActive = _.get(response.data, 'result.isActive', 0)
          type.buildingUses.forEach(element => {
            this.form.buildingUses.push(element.id)
          })
          this.spinner = false
        })
        .catch(error => {
          this.spinner = false
          errorService(error)
        })
    },

    // Get Building Uses
    getBuildingUses() {
      instance
        .post(dropdownAPIs.dropdown, { Building_Use: 0 })
        .then(response => {
          this.buildingUseList = _.get(
            response.data,
            'result.building_use',
            null,
          )
        })
        .catch(error => {
          this.spinner = false
          errorService(error)
        })
    },

    // Save Structure Profile
    save() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.spinner = true
          const buildingUseData = []
          this.form.buildingUses.forEach(element => {
            const type = this.buildingUseList.find(i => i.id === element)
            buildingUseData.push({
              buildingUse: type.option,
              id: type.id,
            })
          })
          instance
            .patch(masterAPIs.structureProfile.details(this.form.id), {
              structureProfile: this.form.structureProfile,
              buildingUses: buildingUseData,
              isActive: this.form.isActive,
            })
            .then(response => {
              this.spinner = false
              this.visible = false
              showNotification(
                'success',
                'Update Structure Profile',
                'Structure Profile updated successfully!',
              )
              if (this.form.id) {
                const newData = [...this.structureProfileList]
                const index = newData.findIndex(i => i.id === this.form.id)
                newData[index] = _.get(response.data, 'result', null)
                this.structureProfileList = newData
              }
              this.$refs.ruleForm.resetFields()
            })
            .catch(error => {
              this.spinner = false
              errorService(error)
            })
        }
      })
    },

    getWindowSize() {
      this.height = calculateGridHeight(
        'proprtyTypeTable',
        this.count > this.pageSize,
      )
    },

    onPagination(page) {
      this.loading = true
      this.page = page
      this.structureProfileList = []
      this.selectedRowKeys = []
      this.getStructureProfiles(this.tableParams)
    },

    filterChanged() {
      this.filters = {}
      const data = this.gridOptions.api.getFilterModel()
      Object.keys(data).forEach((element, index) => {
        this.filters[element] = Object.values(data)[index]['filter']
      })
      this.structureProfileList = []
      this.loading = true
      this.page = 0
      this.getStructureProfiles(this.gridOptions)
    },

    onColumnResized(e) {
      if (e.finished) {
        this.updateColumnSettings()
      }
    },

    updateColumnSettings() {
      if (this.role === 'Admin') {
        this.tableState = this.gridOptions.columnApi.getColumnState()
        const request = {
          type: screenType.structureProfile,
          columnDetails: JSON.stringify(this.tableState),
        }
        this.$emit('updateColumns', request)
      }
    },

    getColumnSettings(params) {
      if (this.role === 'Admin') {
        instance
          .get(masterAPIs.columnSetting.get(screenType.structureProfile))
          .then(response => {
            const tableState = _.get(response.data, 'result.columnDetails', null)
            this.setColumnSettings(params, tableState)
          })
          .catch(error => {
            this.spinner = false
            errorService(error)
          })
      } else {
        this.setColumnSettings(params)
      }
      this.getStructureProfiles(params)
    },

    setColumnSettings(params, tableState) {
      if (tableState && this.role === 'Admin') {
        this.tableState = JSON.parse(tableState)
        if (this.tableState.find(i => i.sort)) {
          this.defaultSortedBy = this.tableState.find(i => i.sort).colId
          this.defaultSortOrder =
            this.tableState.find(i => i.sort).sort === 'asc'
        }
        this.gridOptions.columnApi.applyColumnState({
          state: this.tableState,
        })
      } else {
        this.defaultSortedBy = 'structureProfile'
        this.defaultSortOrder = true
        this.gridOptions.columnApi.applyColumnState({
          state: [
            {
              colId: 'structureProfile',
              sort: 'asc',
            },
            {
              colId: 'action',
              hide: this.role !== 'Admin',
            },
            {
              colId: 'isActive',
              hide: this.role !== 'Admin',
            },
          ],
          defaultState: { sort: null },
        })
        params.api.sizeColumnsToFit()
      }
    },
  },
}
